<template>
  <el-cascader
    ref="cascader"
    :value="categoryCode"
    filterable
    clearable
    :options="options"
    :props="{
      emitPath: false,
      checkStrictly: false,
      value: 'value',
      label: 'label',
    }"
    :showAllLevels="false"
    :disabled="disabled"
    style="width: 100%"
    @change="change"
  >
    <template slot-scope="{ node, data }">
      <span>{{ data.label }}</span>
      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
    </template>
  </el-cascader>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    categoryCode: { type: String, default: '' },
    categoryName: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
    masterCategoryName: { type: String, default: '' },
    displayCategoryCode: { type: String, default: '' },
    displayCategoryName: { type: String, default: '' },
  },
  data() {
    return { options: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$api
        .ecomAmzSpuCategoryApi({ parentCode: 'ABSHome' })
        .catch(() => null)
      if (!res) return
      this.options = res.body?.data || []
    },
    change() {
      const nodes = this.$refs.cascader.getCheckedNodes() || []
      const { pathNodes = [] } = nodes[0] || {}

      const master = pathNodes[0] || {}
      const detail = pathNodes[1] || {}

      const {
        value: masterCategoryCode = '',
        label: masterCategoryName = '',
      } = master
      const {
        value: categoryCode = '',
        label: displayCategoryName = '',
      } = detail
      const displayCategoryCode = [masterCategoryCode, categoryCode].join(',')
      let { label: categoryName = '' } =
        master.children?.find((node) => node.value === categoryCode) || {}
      categoryName = categoryName.replace(`${masterCategoryName}/`, '')

      this.$emit('update:categoryCode', categoryCode)
      this.$emit('update:categoryName', categoryName)
      this.$emit('update:masterCategoryCode', masterCategoryCode)
      this.$emit('update:masterCategoryName', masterCategoryName)
      this.$emit('update:displayCategoryCode', displayCategoryCode)
      this.$emit('update:displayCategoryName', displayCategoryName)
      this.$emit('change', {
        categoryCode,
        categoryName,
        masterCategoryCode,
        masterCategoryName,
        displayCategoryCode,
        displayCategoryName,
      })
    },
  },
}
</script>

<style scoped></style>
